module.exports = __webpack_public_path__ + "img/务川县人民医院.93a51c76.png";